export const URL_ENDPOINT_DON_VI = `${
  process.env.REACT_APP_ENDPOINT_URL
}/don-vi`;

export const DON_VI_PREFIX_URL = "/don-vi";
